(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/payment/assets/javascripts/services/multifetcher.js') >= 0) return;  svs.modules.push('/components/tur/payment/assets/javascripts/services/multifetcher.js');

'use strict';

class Multifetcher {
  constructor(_ref) {
    let {
      urls
    } = _ref;
    if (!Array.isArray(urls)) {
      svs.tur.payment.logger.info("Multifetcher requires an Array but got ".concat(typeof urls));
      return;
    }
    this.urls = urls;
    this.path = "/multifetch?urls=".concat(encodeURI(urls.join('|')));
  }
  fetch() {
    const deferred = $.Deferred();
    if (!this.path) {
      svs.tur.payment.logger.info('Multifetcher has no path. Aborting');
      deferred.reject();
    }
    svs.tur.payment.logger.debug("Multifetcher is calling path: ".concat(this.path));
    svs.core.jupiter.call({
      method: 'GET',
      path: this.path
    }, data => {
      const responseMap = new Map();
      data.responses.forEach((resp, i) => {
        responseMap.set(this.urls[i], resp);
      });
      deferred.resolve({
        responseMap
      });
    }, e => {
      svs.tur.payment.logger.error("Multifetcher failed with error: ".concat(e));
      deferred.reject();
    });
    return deferred.promise();
  }
}
svs.tur.payment.services.Multifetcher = Multifetcher;

 })(window);